/* eslint-disable @typescript-eslint/no-empty-object-type */
/* eslint-disable @typescript-eslint/no-explicit-any */

export class EmptyClass {}

export type GenericBaseClass<T = {}> = new (...args: any[]) => T;

export type AbstractGenericBaseClass<T = {}> = abstract new (...args: any[]) => T;
